<template>
  <nav class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" :class="this.$store.state.isRTL ? 'top-0 position-sticky z-index-sticky' : ''
    " v-bind="$attrs" id="navbarBlur" data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :currentPage="currentRouteName" textWhite="text-white" />

      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="this.$store.state.isRTL ? 'px-0' : 'me-sm-4'" id="navbar">
        <div class="pe-md-3 d-flex align-items-center ms-md-auto">
        </div>
        <ul class="navbar-nav justify-content-end">
          <li v-if="loggedIn" class="nav-item d-flex align-items-center">
            <router-link :to="{ name: 'Profile' }" style="padding-right: 1rem;">
              <span class="avatar avatar-sm rounded-circle">
                <img :src="profileImage()" style="object-fit: cover !important;">
              </span>
            </router-link>
          </li>
          <li v-if="loggedIn" class="nav-item d-flex align-items-center">
            <button class="btn btn-addiuva-yellow mb-0" @click.prevent="handleLogout">
              <i class="ni ni-user-run"></i> Salir
            </button>
          </li>
          <li v-else class="nav-item d-flex align-items-center">
            <router-link :to="{ name: 'Login' }" class="px-0 nav-link font-weight-bold text-white">
              <i class="fa fa-user" :class="this.$store.state.isRTL ? 'ms-sm-2' : 'me-sm-2'"></i>
              <span v-if="this.$store.state.isRTL" class="d-sm-inline d-none">يسجل دخول</span>
              <span v-else class="d-sm-inline d-none">Acceder</span>
            </router-link>
          </li>
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a href="#" @click="toggleSidebar" class="p-0 nav-link text-white" id="iconNavbarSidenav">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapActions } from "vuex";
import placeholder from "../../assets/img/placeholder.jpg";
import showSwal from "../../mixins/showSwal.js";

export default {
  name: "navbar",
  components: {
    Breadcrumbs
  },
  data() {
    return {
      showMenu: false,
      showProfileDropdown: false,
      getNameProfile: null
    };
  },
  props: ["minNav", "textWhite"],
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    loggedIn() {
      return this.$store.getters["auth/isAuthenticated"];
    },
    getProfileNavbar() {
      return this.$store.getters["profile/me"];
    },
    getNameNavbar() {
      return this.getProfileNavbar?.name
    },
    getImageNavbar() {
      return this.getProfileNavbar?.profile_image;
    },

  },
  watch: {
    getProfileNavbar(val) {
      // this.getNameProfile = val?.data.persona.nombres + ' ' + val?.data.persona.apellidos;
      this.getNameProfile = 'Usuario ('+ val?.data.nombre_rol +')';
    }
  },
  mixins: [showSwal],
  created() {
    this.minNav;
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),

    profileImage() {
      return this.getImageNavbar ? this.getImageNavbar : placeholder;
    },
    async handleLogout() {
      try {
        await this.$store.dispatch("auth/logout");
      } finally {
        await this.$router.push({ name: "Login" });
      }
    },

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    }
  },
};
</script>
